import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {Helper} from "../utils/helper.module";
import {isPlatformBrowser} from "@angular/common";
import {LOCAL_STORAGE, WINDOW} from "@ng-toolkit/universal";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class PaymentService {

  constructor(
    @Inject(WINDOW) private window:Window,
    @Inject(LOCAL_STORAGE) private localStorage: any,
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient
  ) {

  }


  doPayment(data): Promise<any> {
    return this.http.post(Helper.api('front/do-payment'), data)
      .toPromise()
      .then((response) => {
        console.log(Promise.resolve(response));
        return Promise.resolve(response);
      })
      .catch(Helper.handleError);
  }

  removeItem(key):Promise<any>
  {
    if (isPlatformBrowser(this.platformId)) {
      try{
        localStorage.removeItem(key);
        return;
      } catch (e) {
        console.log("localStorage not available");
        return null;
      }
    }
  }


  store(key,value):Promise<any>
  {
    if (isPlatformBrowser(this.platformId)) {
      try{
        localStorage.setItem(key, JSON.stringify(value));
        return;
      } catch (e) {
        console.log("localStorage not available");
        return null;
      }
    }
  }

  retrieve(key)
  {
    if (isPlatformBrowser(this.platformId)) {
      try {
        let value=localStorage.getItem(key);
        return JSON.parse(value);
      } catch (e) {
        console.log("localStorage not available");
        return null;
      }
    }
  }

}
